import { boxStyles, textStyles } from '../styles';
import { createUseTagLabelStylesHook } from './createUseTagLabelStylesHook';

/**
 * The complexity of button is largely in the mapping of...
 *   (a) design library props (palette, size, disabled); and
 *   (b) UI event state (hovered/pressed, focused)
 * ...to corresponding style definitions.
 *
 * This is accomplished by having structured style definitions that are consumed
 * by hooks that accept the parameters of the Button component API.
 */
export const useBoxStyles = createUseTagLabelStylesHook(boxStyles);
export const useTextStyles = createUseTagLabelStylesHook(textStyles);
